export default __webpack_public_path__ + "static/media/Check.e13ea747.svg";